import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

type UuidLogin = {
    uuid: string;
    phone: string;
    code: string;
};

type UsernameLogin = {
    user_name: string;
    password: string;
    phone: string;
    code: string;
};

// Union type: must be one or the other
type LoginPayload = UuidLogin | UsernameLogin;

const userCompleteLoginWithSMS = (payload: LoginPayload): ReturnType => {
    return Request.post(`/authentication/sms/complete-login`, payload);
};

export default userCompleteLoginWithSMS;
